import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";
import { ReceiptsScreenViewModel } from "../../viewmodels/receipts/ReceiptsScreenViewModel";
import EmptyModal from "../../components/modals/EmptyModal";
import ImportMediaDropzoneV2 from "../../components/importMedia/ImportMediaDropzoneV2";
import { Skeleton } from "primereact/skeleton";

function ReceiptsScreen(props) {
  const { logout } = props;
  const {
    onUploadReceipt,
    emptyModal,
    setEmptyModelOpen,
    receipt,
    inProgress,
  } = ReceiptsScreenViewModel(logout);

  const fmt = (v) =>
    v == null
      ? "—"
      : v.toLocaleString(undefined, { style: "currency", currency: "USD" });

  return (
    <div>
      <div className="mt-2 lg:px-8 space-y-4">
        <div className="sm:flex sm:items-center px-4 py-5 card-custom">
          <div className="sm:flex-auto space-y-4">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              Upload Receipt
            </h1>

            <ImportMediaDropzoneV2
              onFileSelected={(file) => onUploadReceipt(file)}
            />
          </div>
        </div>
        {inProgress ? (
          <Skeleton width="100%" height="8rem" borderRadius="16px"></Skeleton>
        ) : null}

        {receipt?.success && (
          <div className="mt-2 space-y-1 w-64">
            <div className="flex items-baseline">
              <span>Subtotal:</span>
              <span className="ml-auto font-mono tabular-nums">
                {fmt(receipt.subtotal ?? receipt.derived_subtotal)}
              </span>
            </div>
            <div className="flex items-baseline">
              <span>Tax:</span>
              <span className="ml-auto font-mono tabular-nums">
                {fmt(receipt.tax)}
              </span>
            </div>
            <div className="flex items-baseline border-t pt-1">
              <span className="font-semibold">Total:</span>
              <span className="ml-auto font-mono tabular-nums font-semibold">
                {fmt(receipt.total ?? receipt.derived_total)}
              </span>
            </div>
          </div>
        )}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReceiptsScreen)
);
